import gridHelp from 'svelte-grid/build/helper/index.mjs';
import { writable, get } from 'svelte/store';

export const COLS = 4;
export const MIN = { w: 1, h: 1 };
export const MAX = { w: 2, h: 1 };
export const userid = writable(null);
export const clientID = writable(null);
export const isProduction = writable(null);
export const items = writable({ mobile: [], desktop: [] });

export const id = () => '_' + Math.random().toString(36).substr(2, 9);
export const generateItems = (grid) => {
  let cells = { mobile: [], desktop: [] };
  let devices = ['mobile', 'desktop'];
  devices.forEach((device) => {
    grid[device].reverse().forEach((item) => {
      cells[device] = [...cells[device], generateItem(item)];
    });
    cells[device] = gridHelp.adjust(cells[device], COLS);
  });

  items.set(cells);
  console.log(get(items));
};
export const generateItem = (data) => {
  let itemID = data.id ? data.id : id();
  let carouselMax = data.num_products === 12 || data.type == 'banner' ? { w: 4, h: 1 } : MAX;
  // console.log(data);
  return {
    [COLS]: gridHelp.item({
      w: data.size,
      h: 1,
      max: carouselMax,
      min: MIN,
    }),
    id: itemID,
    data: { ...data, id: itemID, size: data.size },
  };
};
export const putItem = (payload) => {
  let carouselMax = payload.data.num_products === 12 || payload.data.type == 'banner' ? { w: 4, h: 1 } : MAX;
  let cells = get(items);
  const device = payload.device;
  let index = cells[device].findIndex((obj) => obj.id == payload.id);
  cells[device][index][COLS].max = carouselMax;
  // console.log(cells[device][index][COLS].max, payload);
  cells[device] = gridHelp.adjust(cells[device], COLS);
  items.set(cells);
};
export const handleSubmitAction = (payload) => {
  if (payload.delete === true) removeItem(payload);
  else if (payload.edit === true) putItem(payload);
  else addItem(payload);
};
export const addItem = (item) => {
  console.log(item);
  let cells = get(items);
  const device = item.device;
  let newItem = generateItem(item);

  cells[device] = [...cells[device], ...[newItem]];
  cells[device] = gridHelp.adjust(cells[device], COLS);
  items.set(cells);
};
export const removeItem = (item) => {
  console.log(item);
  let cells = get(items);
  const device = item.device;
  cells[device] = cells[device].filter((value) => value.id !== item.id);
  cells[device] = gridHelp.adjust(cells[device], COLS);
  items.set(cells);
};
export const copyToClipboard = (text) => {
  let dummy = document.createElement('textarea');

  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand('copy');
  document.body.removeChild(dummy);
};
